// extracted by mini-css-extract-plugin
export default {"circle":"CirclePhoto_circle__Loo0q","circleGreen":"CirclePhoto_circleGreen__jn8Q+","circleYellow":"CirclePhoto_circleYellow__07gFn"};